export const orgTypes = [
  { code: 1, name: 'Private Limited /Public Limited / LLP' },
  { code: 2, name: 'Sole Proprietorship' },
  { code: 3, name: 'Partnership' },
  { code: 4, name: 'Trust / NGO' },
];